import React from 'react';

import InitiateEval from '../../components/evaluations/InitiateEval';

const NewEval = () => {
  return <InitiateEval renderType="page" />;
};

export default NewEval;
